"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastRowInfo = void 0;
var search_1 = require("@devexpress/utils/lib/utils/search");
var layout_row_1 = require("../../../layout/main-structures/layout-row");
var LastRowInfo = (function () {
    function LastRowInfo(paragraphs) {
        this._row = null;
        this._startPosition = 0;
        this._paragraphIndex = -1;
        this.paragraphs = paragraphs;
    }
    LastRowInfo.prototype.reset = function (rowFormatter) {
        this._row = null;
        this._startPosition = rowFormatter.getPosition();
        this._paragraphIndex = -1;
        this.isParIndexSet = true;
    };
    LastRowInfo.prototype.recalculateParagraphIndex = function (now) {
        this.isParIndexSet = false;
        if (now)
            this.calculateParagraphIndex();
    };
    LastRowInfo.prototype.setRowInfo = function (row, columnFullOffset, isNowRecalcParIndex) {
        this._row = row;
        this._startPosition = columnFullOffset + row.columnOffset;
        this.recalculateParagraphIndex(isNowRecalcParIndex);
    };
    LastRowInfo.prototype.setFullRowInfo = function (row, rowStartPos, parIndex) {
        this._row = row;
        this._startPosition = rowStartPos;
        this._paragraphIndex = parIndex;
        this.isParIndexSet = true;
    };
    LastRowInfo.prototype.setFullRowInfoAndCalculateParagraph = function (row, rowStartPos, calcImmediately) {
        this._row = row;
        this._startPosition = rowStartPos;
        this.recalculateParagraphIndex(calcImmediately);
    };
    Object.defineProperty(LastRowInfo.prototype, "row", {
        get: function () {
            return this._row;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LastRowInfo.prototype, "startPosition", {
        get: function () {
            return this._startPosition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LastRowInfo.prototype, "paragraphIndex", {
        get: function () {
            if (!this.isParIndexSet)
                this.calculateParagraphIndex();
            return this._paragraphIndex;
        },
        enumerable: false,
        configurable: true
    });
    LastRowInfo.prototype.calculateParagraphIndex = function () {
        this._paragraphIndex = search_1.SearchUtils.normedInterpolationIndexOf(this.paragraphs, function (p) { return p.startLogPosition.value; }, this._startPosition);
        this.isParIndexSet = true;
    };
    LastRowInfo.prototype.isNextRowFirstInParagraph = function () {
        return !this._row || this._row.flags.get(layout_row_1.LayoutRowStateFlags.ParagraphEnd);
    };
    return LastRowInfo;
}());
exports.LastRowInfo = LastRowInfo;
